export { default as ImageDocumentDetails } from './ImageDocumentDetails.vue';
